export default __webpack_public_path__ + "assets/favicon-256x256.9d68ed5dd960bf6d18cfd8647930453c.png";